import { faCheck, faExclamationTriangle, faClose, faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Box, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import { BlueHoverButton } from "../../../../components/Inputs/BlueHoverButton";
import { base64toBlob } from "../../../../infra/utils/Files";
import { downloadConteudoBase64 } from "../../../../infra/utils/DownloadFile";
import servAnalises from "../../../../services/login/servAnalises";
import styles from "../../../SolicitacaoAcessoAnalise/SolicitacaoAcessoAnalise.module.css";
import Popup from "../../../../components/Popup";
import { Anexos } from "../../anexos/Anexos";

const SituacaoAnalise = ({
    Situacao, 
    TipoParecer, 
    Parecer, 
    CodigoAnalise,
    setSeverity,
    setOpenDownload,
    setDownloadMessage,
    SituacaoSolicAcesso,
    SituacaoAnalise,
    openVisualizarOutrosAnexos,
    setOpenVisualizarOutrosAnexos,
    anexos
}) => {
    const [docsParaDownload, setDocsParaDownloads] = useState([]);

    useEffect(() => {

        const recuperarDocs = async () => {
            try {
                const docs = await servAnalises.RecuperarDocumentosSolicAcesso(CodigoAnalise);
                
                if(docs.Success) {
                    let documentos = docs.Content,
                        parecerAnalise = documentos.find(doc => doc.TipoDocumento == 1);

                    if (parecerAnalise) {
                        const parecerAnaliseAssinado = await servAnalises.RecuperarParecerAnaliseAssinado({CodigoOrigem: 'PGD_PA' + parecerAnalise.CodigoSolicitacaoAnalise});

                        if(parecerAnaliseAssinado.Success) {
                            documentos.push(parecerAnaliseAssinado.Content);
                            documentos = documentos.filter(doc => doc.TipoDocumento != 1);
                        }
                    }

                    setDocsParaDownloads(documentos);
                }
            } catch (err) {
                console.log(err);
            }
        }

        if (CodigoAnalise && Situacao !== 1 && TipoParecer === "geral") {
            recuperarDocs();
        }

    }, []);

    const handleDownloadRelacionamentoOperacional = async (codigoDocumento) => {
        try {

            if (CodigoAnalise) {
                setOpenDownload(true);
                setSeverity("info");
                setDownloadMessage("Iniciando download do documento...");

                let data = await servAnalises.DownloadParecerSolicA({
                    CodigoAnalise: CodigoAnalise,
                    CodigoDocumento : codigoDocumento
                });

                setOpenDownload(true);
                setSeverity("success");
                setDownloadMessage("Download iniciado com sucesso...");

                downloadConteudoBase64(data.Content.Nome, data.Content.Arquivo);
            }

        } catch (err) {
            setSeverity("error");
            setOpenDownload(true);
            let statusErrorMessage = err.response.status + " - " + err.response.statusText;

            setDownloadMessage(err.response.data.Message ? err.response.data.Message : statusErrorMessage);
        }
    }

    const handleVisualizarParecer = async (codigoDocumento) => {
        try {
            if (CodigoAnalise) {
                let data = await servAnalises.DownloadParecerSolicA({
                    CodigoAnalise: CodigoAnalise,
                    CodigoDocumento : codigoDocumento
                });

                var blob = base64toBlob(data.Content.Arquivo, "application/pdf");
                
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                } else {
                    const blobUrl = URL.createObjectURL(blob);
                    window.open(blobUrl, "_blank");
                }
            }

        } catch (err) {
            setSeverity("error");
            setOpenDownload(true);
            let statusErrorMessage = err.response.status + " - " + err.response.statusText;

            setDownloadMessage(err.response.data.Message ? err.response.data.Message : statusErrorMessage);
        }
    }

    const handleVisualizarParecerAssinado = async (linkParecer) => {
        if (linkParecer) {
            window.open(linkParecer, "_blank");
        }
    }

    return (
        <div className={styles.situacaoAnalise}>
            <div className={
                    Situacao == 1 
                    ? `${styles.resultadoAnaliseParcial} + ${styles.NaoAvaliado}`
                    : Situacao == 2 
                    ? `${styles.resultadoAnaliseParcial} + ${styles.Favoravel}`
                    : Situacao == 3
                    ? `${styles.resultadoAnaliseParcial} + ${styles.FavoravelRessalvas}` 
                    : `${styles.resultadoAnaliseParcial} + ${styles.Reprovado}`
            }>
                <h3>Parecer { TipoParecer }</h3>
                <div className={styles.parecerSituacao}>
                Situação:  
                    {
                          SituacaoSolicAcesso !== 1 && Situacao === 1
                        ? " Não avaliado" 
                        : SituacaoSolicAcesso !== 1 && Situacao === 2
                        ? " Favorável" 
                        : SituacaoSolicAcesso !== 1 && Situacao === 3
                        ? " Favorável com Ressalvas"
                        : SituacaoSolicAcesso !== 1 && Situacao === 4
                        ? " Reprovada"
                        : " Não avaliado"
                    }    
                    <p><FontAwesomeIcon 
                        size="lg"
                        icon=
                        {
                              SituacaoSolicAcesso !== 1 && Situacao === 1 
                            ? faPen
                            : SituacaoSolicAcesso !== 1 && Situacao === 2
                            ? faCheck 
                            : SituacaoSolicAcesso !== 1 && Situacao === 3
                            ? faExclamationTriangle
                            : SituacaoSolicAcesso !== 1 && Situacao === 4 
                            ? faClose
                            : ""
                        }
                        />
                    </p>
                </div>
            </div>
            {(Situacao !== 1 && TipoParecer === "geral") && (
                <div>
                    {docsParaDownload.map((item, index) => (
                        (SituacaoSolicAcesso !== 1 && (
                            <div key={index} style={{ display: "flex", alignItems: "center" }}>
                                {item.Arquivo ? (
                                    <BlueHoverButton onClick={() => handleVisualizarParecerAssinado(item.Arquivo)} sx={{ marginRight: 3 }}>Visualizar parecer assinado</BlueHoverButton>
                                ) : item.TipoDocumento === 1 ? (
                                    <BlueHoverButton style={{ marginTop: "10px" }} onClick={() => handleVisualizarParecer(item.CodigoDocumento)} sx={{ marginRight: 3 }}>Visualizar parecer análise</BlueHoverButton>
                                ) : (
                                    <BlueHoverButton style={{ marginTop: "10px" }} onClick={() => handleDownloadRelacionamentoOperacional(item.CodigoDocumento)} sx={{ marginRight: 3 }}>Baixar relacionamento operacional</BlueHoverButton>
                                )}
                            </div>
                        ))
                    ))}
                    { anexos && anexos.length > 0 && (
                        <div style={{ marginTop: "10px" }}>
                            <BlueHoverButton onClick={() => setOpenVisualizarOutrosAnexos(true)}>Outros anexos</BlueHoverButton>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

const VisualizarAnalise = ({ record, recordForView, anexos }) => { 
    const [severity, setSeverity] = useState("info");
    const [openDownload, setOpenDownload] = useState(false);
    const [downloadMessage, setDownloadMessage] = useState("");
    const [openVisualizarOutrosAnexos, setOpenVisualizarOutrosAnexos] = useState(false);

    const handleCloseInfo = (event, reason) => {
        if (reason  === 'clickaway') {
            setOpenDownload(false);
        }

        setOpenDownload(false);
    }

    if (!record) {
        return (
            <div className={styles['resultado-analise']}>
                <Box style={{ margin: '25px auto 0 auto' }}>Análise não encontrada.</Box>
            </div>
        );
    }

    return (
        <div className={styles.modalMain}>
             <SituacaoAnalise 
                Situacao={record.ParecerGeral} 
                TipoParecer="geral" 
                Parecer="" 
                CodigoAnalise={record.Id}
                setSeverity={setSeverity}
                setOpenDownload={setOpenDownload}
                setDownloadMessage={setDownloadMessage}
                SituacaoSolicAcesso = {record.Situacao}
                SituacaoAnalise = {record.SolicitacaoDeAcesso.Situacao}
                openVisualizarOutrosAnexos = {openVisualizarOutrosAnexos}
                setOpenVisualizarOutrosAnexos = {setOpenVisualizarOutrosAnexos}
                anexos={anexos}
            />
            <SituacaoAnalise 
                Situacao={record.ParecerDocumentos} 
                TipoParecer="dos documentos" 
                Parecer={
                    record.ParecerDocumentos === 3 
                    ? record.RessalvaDocumento
                    : record.ParecerDocumentos === 4
                    ? record.MotReprovDocumento
                    : ""
                } 
                SituacaoSolicAcesso = {record.Situacao}   
                SituacaoAnalise = {record.SolicitacaoDeAcesso.Situacao}
                anexos={anexos}
            />
            <SituacaoAnalise 
                Situacao={record.ParecerEquipamento} 
                TipoParecer="dos equipamentos"
                Parecer={
                    record.ParecerEquipamento === 3 
                    ? record.RessalvaEquipamento
                    : record.ParecerEquipamento === 4
                    ? record.MotReprovEquipamento
                    : ""
                }   
                SituacaoSolicAcesso = {record.Situacao}
                SituacaoAnalise = {record.SolicitacaoDeAcesso.Situacao}
                anexos={anexos}
            />
            <SituacaoAnalise 
                Situacao={record.ParecerProjeto} 
                TipoParecer="do projeto" 
                Parecer={
                    record.ParecerProjeto === 3 
                    ? record.RessalvaProjeto
                    : record.ParecerProjeto === 4
                    ? record.MotReprovProjeto
                    : ""
                }   
                SituacaoSolicAcesso = {record.Situacao}
                SituacaoAnalise = {record.SolicitacaoDeAcesso.Situacao}
                anexos={anexos}
            />
            <SituacaoAnalise 
                Situacao={record.ParecerViabTecnica} 
                TipoParecer="da viabilidade técnica" 
                Parecer={
                    record.ParecerViabTecnica === 3 
                    ? record.RessalvaViabTecnica
                    : record.ParecerViabTecnica === 4
                    ? record.MotReprovViabTecnica
                    : ""
                }   
                SituacaoSolicAcesso = {record.Situacao}
                SituacaoAnalise = {record.SolicitacaoDeAcesso.Situacao}
                anexos={anexos}
            />
            <Snackbar open={openDownload} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={1000} onClose={handleCloseInfo}>
                <Alert onClose={handleCloseInfo} severity={severity} sx={{ width: '100%'}} >
                    {downloadMessage}
                </Alert>
            </Snackbar>

            <Popup title="Anexos" openPopup={openVisualizarOutrosAnexos} setOpenPopup={setOpenVisualizarOutrosAnexos} minHeight="100px">
                <Anexos 
                    setOpenPopup={setOpenVisualizarOutrosAnexos}
                    recordForEdit={record}
                    recordForView={recordForView}
                    anexos={anexos}
                />
            </Popup>
        </div>
    )
}

export { VisualizarAnalise }